/**
 * @copyright 2026 Cooltrax Pty Ltd. All rights reserved.
 */

import { type HistoryPalette, getColorLegendEntries } from './palette'
import { REEFER_DETAIL_ROWS } from './statusRows'

export interface RowLegendEntry {
  key: string
  label: string
  color: string
}

/**
 * The color key shown when hovering a status row's label, as Refresh does: one swatch per
 * state the row's bars can take. Only the state rows have one — Power State, the reefer
 * detail rows and each zone's mode. The Power State bar draws only the on runs, so its key
 * is just Reefer On. Null for every other row (headers, movement, alarms, geofences).
 */
export const rowLegendEntries = (palette: HistoryPalette, rowKey: string): RowLegendEntry[] | null => {
  if (rowKey === 'power') {
    return getColorLegendEntries(palette, 'powerState').filter((entry) => entry.key === 'O')
  }
  if (rowKey.startsWith('zoneMode:')) {
    return getColorLegendEntries(palette, 'zoneMode')
  }
  const detail = REEFER_DETAIL_ROWS.find(({ field }) => rowKey === `reefer:${field}`)
  return detail ? getColorLegendEntries(palette, detail.field) : null
}
